import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";
import fileDownload from "js-file-download";
import "./EstudiosPaciente.css";

import {
  IonActionSheet,
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonModal,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import {
  cloudDownload,
  cloudDownloadOutline,
  chevronDown,
  eye,
  eyeOutline,
} from "ionicons/icons";

import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import useTituloPagina from "../../hooks/tituloPagina";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function EstudiosPaciente() {
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [tituloPagina, setTituloPagina] = useState("");
  const [urlAxioPP, setUrlAxio] = useState("");
  const [listadoEstudios, setListadoEstudios] = useState([]);
  const [listadoEstudiosFiltrados, setListadoEstudiosFiltrados] = useState([]);
  const [estudioSel, setEstudioSel] = useState(-1);
  const [listadoEstudiosFiltro, setListadoEstudiosFiltro] = useState([]);
  const [estudioPdf, setEstudioPdf] = useState({
    fecha: "",
    nombre: "",
    doc: {},
  });
  const [abrirModal, setAbrirModal] = useState(false);
  const [abrirDesplegableTipoEstudio, setAbrirDesplegableTipoEstudio] =
    useState(false);

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };
  const history = useHistory();
  useTituloPagina();

  const abrirCerrarModal = () => setAbrirModal(!abrirModal);

  const traerEstudiosPaciente = async (paciente) => {
    let estudios = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(
        `${url}EstudiosImagenes/TraerNombresArchivos/${paciente.documentoNro}`,
        config
      );
      if (response.data.length !== 0) {
        estudios = response.data;
      } else {
        estudios = [];
      }

      estudios = estudios.map((estudio, i) => {
        let nombre = estudio.nombre;
        nombre = nombre.replace(`${paciente.documentoNro}_`, "");
        nombre = nombre.replace(".pdf", "");
        nombre = nombre.replace(".pdf", "");
        const [dia, mes, anio] = nombre.substr(-8).replace(" ", "").split(".");

        const fecha = dayjs(estudio.fechaModificacion);
        if (
          fecha.isValid() &&
          (fecha.isBefore(dayjs()) || dayjs().isSame(fecha))
        ) {
          return {
            ...estudio,
            codigo: i,
            fecha: fecha.format("DD/MM/YYYY"),
            text: nombre.substr(
              0,
              nombre.substr(-11, 3) === " - "
                ? nombre.length - 11
                : nombre.length - 8
            ),
          };
        } else {
          return {
            ...estudio,
            codigo: i,
            fecha: "No disponible",
            text: nombre,
          };
        }
      });
      setListadoEstudios(estudios);
      setListadoEstudiosFiltrados(estudios);
      setListadoEstudiosFiltro(estudios);
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };

  const FiltrarEstudios = (value) => {
    setCargando(true);
    if (value !== -1) {
      let listado = [];

      listadoEstudios.map((estudio) => {
        if (parseInt(value) === estudio.estudioCod) {
          listado.push(estudio);
        }
      });
      setEstudioSel(value);
      setListadoEstudiosFiltrados(listado);
    } else {
      setEstudioSel(value);
      setListadoEstudiosFiltrados(listadoEstudios);
    }
    setCargando(false);
  };

  const BuscarEstudio = async (estudio, pdfDoc, pdfUrl) => {
    const formato = estudio.nombre.split(".")[-1];
    try {
      const response = await axios.request({
        url: `${urlAxioPP}EstudiosImagenes/DescargarGaImagenesPdf/${usuario.documentoNro}?nombreArchivo=${estudio.nombre}&formato=${formato}`,
        method: "GET",
        responseType: "blob",
        auth: `Bearer ${usuario.token}`,
      });

      if (response.data.size > 0) {
        const pdfBlob = new Blob([response.data]);
        if (pdfDoc && !pdfUrl) {
          fileDownload(pdfBlob, `${estudio.text}.pdf`);
        } else {
          if (!pdfDoc && pdfUrl) {
            setEstudioPdf({
              fecha: estudio.fecha,
              nombre: estudio.text,
              doc: pdfBlob,
            });
            abrirCerrarModal();
          }
        }
      }
    } catch (error) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar buscar el estudio seleccionado",
        "rojo"
      );
    }

    return null;
  };

  const BuscarPedido = async (estudio, pdfDoc, pdfUrl) => {
    try {
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: {
          Authorization: `Bearer ${usuario.token}`,
          responseType: "blob",
        },
      };

      let response;
      switch (estudio.estudioNom) {
        case "PAP":
          response = await axios.request({
            url: `${url}EstudiosImagenes/DescargarPAPPdf/${
              usuario.documentoNro
            }?fecha=${dayjs(estudio.fecha).format("DDMMYYYY")}`,
            method: "GET",
            responseType: "blob",
            auth: `Bearer ${usuario.token}`,
          });
          break;
        case "VideoColposcopia":
          response = await axios.request({
            url: `${url}EstudiosImagenes/DescargarVideocolposcopiaPdf/${
              usuario.documentoNro
            }?fecha=${dayjs(estudio.fecha).format("DDMMYYYY")}`,
            method: "GET",
            responseType: "blob",
            auth: `Bearer ${usuario.token}`,
          });
          break;
        case "Colposcopia":
          response = await axios.request({
            url: `${url}EstudiosImagenes/DescargarColposcopiaPdf/${
              usuario.documentoNro
            }?fecha=${dayjs(estudio.fecha).format("DDMMYYYY")}`,
            method: "GET",
            responseType: "blob",
            auth: `Bearer ${usuario.token}`,
          });
          break;
        default:
          mostrarNotificacion(true, "Estudio no disponible", "rojo");
      }
      if (response.data.size > 0) {
        const pdfBlob = new Blob([response.data]);
        if (pdfDoc && !pdfUrl) {
          fileDownload(
            pdfBlob,
            `${estudio.estudioNom}-${dayjs(estudio.fecha).format(
              "DD/MM/YYYY"
            )}.pdf`
          );
        } else {
          if (!pdfDoc && pdfUrl) {
            setEstudioPdf({
              fecha: estudio.fecha,
              nombre: estudio.estudioNom,
              doc: pdfBlob,
            });
            abrirCerrarModal();
          }
        }
      }
    } catch (error) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar buscar el estudio seleccionado",
        "rojo"
      );
    }

    return null;
  };

  const DescargarPdf = (estudio) => {
    setCargando(true);
    if (estudio) {
      BuscarEstudio(estudio, true, false);
    } else {
      mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
    }
    setCargando(false);
  };

  const VisualizarPdf = (estudio) => {
    setCargando(true);
    if (estudio) {
      BuscarEstudio(estudio, false, true);
    } else {
      mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
    }
    setCargando(false);
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        traerEstudiosPaciente(sesion);
        setUsuario(sesion);
        setUrlAxio(localStorage.getItem("urlAxioPP"));
        setTituloPagina(localStorage.getItem("nombreClinica"));
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  //cosas para el modal
  const [numPages, setNumPages] = React.useState(null);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const getTipoEstudio = (estudio) => {
    const tipo = String(estudio.estudioNom || "").trim();
    return tipo || "Estudios oftalmológicos";
  };

  const estudiosPorTipo = listadoEstudiosFiltrados.reduce(
    (grupos, estudio) => {
      const tipo = getTipoEstudio(estudio);
      if (!grupos[tipo]) grupos[tipo] = [];
      grupos[tipo].push(estudio);
      return grupos;
    },
    {}
  );

  return (
    <>
      {listadoEstudios.length <= 0 ? (
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol>
              <div className="ion-text-center">
                <p>No tiene estudios registrados aun</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      ) : (
        <>
          <section className="estudios-accordion-list" aria-label="Mis estudios">
            {Object.entries(estudiosPorTipo).map(([tipo, estudios]) => (
              <details className="estudios-accordion" key={tipo}>
                <summary className="estudios-accordion-summary">
                  <span className="estudios-accordion-icon" aria-hidden="true">
                    🔎
                  </span>
                  <span className="estudios-accordion-title">{tipo}</span>
                  <span className="estudios-accordion-count">
                    {estudios.length} {estudios.length === 1 ? "estudio" : "estudios"}
                  </span>
                  <IonIcon className="estudios-accordion-chevron" icon={chevronDown} />
                </summary>

                <div className="estudios-accordion-content">
                  {estudios.map((fila) => (
                    <article className="estudio-item" key={fila.codigo}>
                      <span className="estudio-item-indicator" aria-hidden="true" />
                      <div className="estudio-item-info">
                        <p className="estudio-item-name" title={fila.text}>
                          {fila.text}
                        </p>
                        <p className="estudio-item-date">📅 {fila.fecha}</p>
                      </div>
                      <div className="estudio-item-actions">
                        <IonButton
                          className="estudio-action estudio-action-view"
                          aria-label={`Visualizar ${fila.text}`}
                          onClick={() => VisualizarPdf(fila)}
                        >
                          <IonIcon ios={eyeOutline} md={eye} />
                        </IonButton>
                        <IonButton
                          className="estudio-action estudio-action-download"
                          aria-label={`Descargar ${fila.text}`}
                          onClick={() => DescargarPdf(fila)}
                        >
                          <IonIcon ios={cloudDownloadOutline} md={cloudDownload} />
                        </IonButton>
                      </div>
                    </article>
                  ))}
                </div>
              </details>
            ))}
          </section>

          <IonActionSheet
            header={`${estudioPdf.nombre}-${dayjs(estudioPdf.fecha).format(
              "DD/MM/YYYY"
            )}`}
            buttons={[
              {
                text: "Cancelar",
                role: "cancel",
                data: {
                  action: "cancel",
                },
              },
            ]}
            onDidDismiss={abrirCerrarModal}
          >
            <IonContent className="ion-padding">
              {estudioPdf.doc && (
                <Document
                  file={estudioPdf.doc}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  {[...Array(numPages)].map((_, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={1}
                      renderTextLayer={false}
                      wrap={false}
                    />
                  ))}
                </Document>
              )}
            </IonContent>
          </IonActionSheet>
          <IonModal isOpen={abrirModal} backdropDismiss={false} expand="block">
            <IonHeader>
              <IonToolbar>
                <IonTitle>{`${estudioPdf.nombre} - ${estudioPdf.fecha}`}</IonTitle>
                {/* <IonButtons slot="end"> */}
                <StyledButton
                  slot="end"
                  strong={true}
                  onClick={() => abrirCerrarModal()}
                  fill="clear"
                  className="amarillo-sol-text"
                >
                  Cerrar
                </StyledButton>
                {/* </IonButtons> */}
              </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
              {estudioPdf.doc && (
                <Document
                  file={estudioPdf.doc}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  {[...Array(numPages)].map((_, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={1}
                      renderTextLayer={false}
                      wrap={false}
                    />
                  ))}
                </Document>
              )}
            </IonContent>
          </IonModal>
          <CustomToast
            openToast={toast.open}
            onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
            message={toast.mensaje}
            colorNotificacion={toast.tipo}
          />
        </>
      )}
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
